import { listRecognitionRecipients } from '@kudos/http-client'
import TenantMembersAndTeamsSearchField from '@shared/forms/tenantMemberAndTeamSearchField/TenantMemberAndTeamSearchField'
import { RecognitionFormData } from '@tenant/recognition/RecognitionModal/sendRecognitionView/useSendRecognitionForm'
import { useFormContext } from 'react-hook-form'

const MobileRecognitionRecipientsView = () => {
  const { control } = useFormContext<RecognitionFormData>()

  return (
    <TenantMembersAndTeamsSearchField
      control={control}
      name="sendTo"
      searchFn={listRecognitionRecipients}
      showAvatars
      zIndexPlacement="modal"
    />
  )
}

export default MobileRecognitionRecipientsView
